module.exports = __webpack_public_path__ + "img/icon_map_13_on_010.ab779ac8.png";